import { render, staticRenderFns } from "./KInfoBox.vue?vue&type=template&id=400b4a98&scoped=true&"
import script from "./KInfoBox.vue?vue&type=script&lang=js&"
export * from "./KInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./KInfoBox.vue?vue&type=style&index=0&id=400b4a98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400b4a98",
  null
  
)

export default component.exports